// import './index.scss';
import emitter from '../../Helper/emitter';
import React, { useEffect, useRef, useState } from "react";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import './index.scss';

// default aspectRatio 3/2
function ModalImageCroper({fileCrop, aspectRatio, isMobileBuilder=false}) {

    const [crop, setCrop] = useState();
    const [imgSrc, setImgSrc] = useState('');
    const imagePreview = useRef(null);

    const handleModalClose = (file) => {
        if (typeof file !== 'undefined') {
            emitter.emit('tbcourse-modal-image-control-cropper:modal-close', file);
        }
        window.jQuery('#tbcourse-modal-image-control-cropper').modal('hide');
    }

    const getFile = () => {
        const image = imagePreview.current;
        const pixelRatio = window.devicePixelRatio ?? 1;
        // const scaleX = 1;
        // const scaleY = 1;

        // crop tetap undefined kalau user belum pernah menggambar seleksi (ReactCrop tidak
        // auto-init) - jatuh ke full-image supaya Save Crop tidak crash.
        const effectiveCrop = crop ?? { x: 0, y: 0, width: image.width, height: image.height };

        const container = document.querySelector( ".ReactCrop__child-wrapper" );
        const containerWidth = container.offsetWidth;
        const containerHeight = container.offsetHeight;
        const leftDistance = containerWidth / 2 - image.width / 2;
        const topDistance = containerHeight / 2 - image.height / 2;

        const canvas = document.createElement('canvas');
        const scaleX = image.naturalWidth / image.width;
        const scaleY = image.naturalHeight / image.height;
        canvas.width = effectiveCrop.width;
        canvas.height = effectiveCrop.height;
        const ctx = canvas.getContext('2d');

        // canvas.width = Math.floor(effectiveCrop.width * scaleX * pixelRatio);
        // canvas.height = Math.floor(effectiveCrop.height * scaleY * pixelRatio);

        canvas.width = effectiveCrop.width * pixelRatio;
        canvas.height = effectiveCrop.height * pixelRatio;
        ctx.setTransform( pixelRatio, 0, 0, pixelRatio, 0, 0 );

        const cropX = effectiveCrop.x * scaleX;
        const cropY = effectiveCrop.y * scaleY;

        // ctx.scale(pixelRatio, pixelRatio);
        ctx.imageSmoothingQuality = 'high';
        ctx.save();
        ctx.clearRect(0, 0, canvas.width, canvas.height);
        // ctx.drawImage(image, cropX, cropY, canvas.width, canvas.height, 0, 0, canvas.width, canvas.height);
        ctx.drawImage(
            image,
            effectiveCrop.x * scaleX - leftDistance * scaleX,
            effectiveCrop.y * scaleY - topDistance * scaleY,
            effectiveCrop.width * scaleX,
            effectiveCrop.height * scaleY,
            0,
            0,
            effectiveCrop.width,
            effectiveCrop.height,
            );
        ctx.restore();
        let url = canvas.toDataURL();
        canvas.remove();
        return url;
    }

    const fileToBase64 = (file) => {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsDataURL(file);
        });
      }

      useEffect(()=>{
        (async () => {
            setImgSrc(fileCrop ? await fileToBase64(fileCrop) : '');
          })();
      });

    const imageStyle = {
        height: `100%`,
        minHeight:'50px',
        minWidth: isMobileBuilder ? '300px' : '500px',
    };

    return (
        <div className="tbcourse-modal tbcourse-modal-image-control-cropper modal" id="tbcourse-modal-image-control-cropper" data-backdrop="static" data-keyboard="false" tabIndex="-1" role="dialog" aria-hidden="true">
            <div className="modal-dialog" role="document">
                <div className="modal-content">
                    <div className="modal-header">
                        {/* <button type="button" className="close" aria-label="Close" onClick={() => {handleModalClose()}}>
                            <span aria-hidden="true">
                                <IconCross/>
                            </span>
                        </button> */}
                        <h5 className="modal-title">Image Cropper</h5>
                        <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close" onClick={() => {handleModalClose()}}></button>
                    </div>
                    <div className="modal-body">
                        <div className='image-crop-frame d-flex justify-content-center'>
                            <ReactCrop
                                crop={crop}
                                aspect={aspectRatio}
                                center={true}
                                onChange={c => setCrop(c)}
                                minWidth={100}
                                minHeight={100}
                                >
                                <img
                                    src={imgSrc}
                                    alt=''
                                    ref={imagePreview}
                                    style={imageStyle}
                                    crossOrigin="anonymous"
                                    />
                            </ReactCrop>
                        </div>
                    </div>
                    <div className="modal-footer">
                        <button type="button" className="btn btn-primary rounded-12 px-4 font-size-12 fw-bold" onClick={() => {handleModalClose(getFile())}}>Save Crop</button>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ModalImageCroper;
